import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-datenschutz',
  templateUrl: './datenschutz.component.html',
  styleUrls: ['./../app.component.css']
})
export class DatenschutzComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
